<template>

  <a-card :bordered="false">
    <Breadcrumb routeName="home" toName="最新动态" goPathName="概况"></Breadcrumb>
    <custom-page-table
      ref="table"
      rowKey="id"
      :columns="columns"
      :requestPromise="loadPromise">
      <span slot="slotTitle" slot-scope="rowItem">
        <a style="color:#000" target="_blank" :href="rowItem.record.content">{{ rowItem.record.title }}</a>
      </span>
    </custom-page-table>
  </a-card>

</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'

export default {
  name: 'Dynamics',
  components: { Breadcrumb },
  data() {
    return {
      columns: [
        {
          colSpan: 0,
          title: '消息',
          dataIndex: 'title',
          scopedSlots: { customRender: 'slotTitle' }
        },
        {
          title: '时间',
          dataIndex: 'publishTime',
          colSpan: 0,
          width: 200
        }
      ],
      loadPromise: params => this.getRequest(params)
    }
  },
  methods: {
    getRequest(params) {
      return this.getHttpServices().getUserService().get('api/v2/announce/showBanner')
    }
  }

}
</script>
<style scoped>
</style>